export default "__VITE_PUBLIC_ASSET__11ab939c__"